"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParents = exports.getRelations = exports.getDescendants = exports.getAncestors = void 0;
var casing_1 = require("./casing");
var lists_1 = require("./lists");
var getAncestors = function (configuration, menuItemConfigs, traversed, sourcePath) {
    var e_1, _a;
    if (traversed === void 0) { traversed = {}; }
    if (sourcePath === void 0) { sourcePath = []; }
    var ancestors = [];
    try {
        for (var _b = __values((0, exports.getParents)(configuration, menuItemConfigs)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var parent_1 = _c.value;
            if (!parent_1.primaryRelationship)
                continue;
            var hash = "".concat(parent_1.collection, ":").concat(parent_1.name);
            if (traversed[hash])
                continue;
            traversed[hash] = true;
            var parentSourcePath = __spreadArray(__spreadArray([], __read(sourcePath), false), [
                {
                    collection: parent_1.collection,
                    name: parent_1.name,
                },
            ], false);
            ancestors.push({
                collection: parent_1.collection,
                name: parent_1.collectionCasing.pluralCamel,
                sourcePath: parentSourcePath,
            });
            ancestors.push.apply(ancestors, __spreadArray([], __read((0, exports.getAncestors)(menuItemConfigs[parent_1.collection], menuItemConfigs, traversed, parentSourcePath)), false));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return ancestors;
};
exports.getAncestors = getAncestors;
var getDescendants = function (configuration, menuItemConfigs, traversed, sourcePath) {
    var e_2, _a;
    if (traversed === void 0) { traversed = {}; }
    if (sourcePath === void 0) { sourcePath = []; }
    var descendants = [];
    try {
        for (var _b = __values(configuration.lists), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            if (!child.primaryRelationship)
                continue;
            var hash = "".concat(child.collection, ":").concat(child.name);
            if (traversed[hash])
                continue;
            traversed[hash] = true;
            var childSourcePath = __spreadArray(__spreadArray([], __read(sourcePath), false), [
                {
                    collection: child.collection,
                    name: child.name,
                },
            ], false);
            descendants.push({
                collection: child.collection,
                name: child.name,
                sourcePath: childSourcePath,
            });
            descendants.push.apply(descendants, __spreadArray([], __read((0, exports.getDescendants)(menuItemConfigs[child.collection], menuItemConfigs, traversed, childSourcePath)), false));
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return descendants;
};
exports.getDescendants = getDescendants;
var getRelations = function (configuration, menuItemConfigs) {
    return {
        ancestors: (0, exports.getAncestors)(configuration, menuItemConfigs),
        descendants: (0, exports.getDescendants)(configuration, menuItemConfigs),
    };
};
exports.getRelations = getRelations;
var getParents = function (configuration, menuItemConfigs) {
    return Object.values(menuItemConfigs).reduce(function (acc, config) {
        var name = config.name, lists = config.lists;
        (0, lists_1.getLists)(lists, menuItemConfigs).forEach(function (list) {
            if (list.collection === configuration.name)
                acc.push(__assign(__assign({}, list), { collection: name, collectionCasing: (0, casing_1.getCasing)(config) }));
        });
        return acc;
    }, []);
};
exports.getParents = getParents;
//# sourceMappingURL=relatives.js.map